import {
  Button,
  Col,
  Row,
  Skeleton,
  Space,
  Table,
  Tooltip,
  Modal,
  Form,
  Spin,
} from 'antd'
import AsyncButton from '@/components/AsyncButton'
import UrgentOrder from '@/components/Icons/UrgentOrder'
import OutdateOrder from '@/components/Icons/OutdateOrder'
import { useMemo, useRef, useEffect } from 'react'
import styles from './styles.module.scss'
import CustomDivider from '@/components/CustomDivider'
import {
  supplierInquiryItemStatusEnum,
  supplierInquiryStatusEnum,
} from '@/global/enum'
import { useSetupHook } from './hooks'
import { formatTime } from '@/tools'
import InquiryStatusAdminTag from '@/components/Icons/tags/InquiryStatusAdminTag'
import { AttachmentPreview } from './components/AttachmentPreview'
import BJDForm from './components/BJDForm'
import XJForm, { XJFormRef } from './components/XJForm'
import RadioTabs from '@/components/RadioTabs'
import ImportTemplateModal from '@/components/ImportTemplateModal'
import { Template_url_inquiryImportSCP } from '@/api/template'
import { ColumnsType } from 'antd/lib/table'
import { QuotationItemDTO } from '@/api/inquiry'
import { cn } from '@xhgj/xh-jsutils'
import { XhTableColumnTypeV5, XhTableV5 } from '@xhgj/xh-components'
export function getInquiryListRowKey(record: QuotationItemDTO) {
  return record.inquiryItemId || ''
}
function isQuotationInfoEmpty(record: QuotationItemDTO) {
  // return !record.quoteUnitCode
  // itemStatus为空时当作待报价
  return (
    supplierInquiryItemStatusEnum.isValueInLabels(record.itemStatus, [
      '待报价',
    ]) || !record.itemStatus
  )
}
function isItemTerminal(record: QuotationItemDTO) {
  return supplierInquiryItemStatusEnum.isValueInLabels(record.itemStatus, [
    '已放弃',
    '无需报价',
  ])
}
export default function InquiryDetail() {
  const {
    state,
    toggleHideClientInfo,
    refreshPage,
    form,
    editForm,
    bjdFormRef,
    handleConfirmOrder,
    handleSubmitQuotation,
    handleTempSave,
    submitDetailList,
    handleExport,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
    currentTableMemo,
    setCurrentTabKey,
    setQuotationPageOption,
    openEditModalForRecord,
    closeEditModal,
    handleGiveUpQuotation,
  } = useSetupHook()
  const { detailInfo, isLoading, hideClientInfo, quotationItemsPage } = state

  const xjFormRef = useRef<XJFormRef>(null)

  useEffect(() => {
    if (state.editModalOpen && state.editTabIndex !== undefined) {
      xjFormRef.current?.switchToTab(state.editTabIndex!)
    }
  }, [state.editModalOpen, state.editTabIndex])

  const detailMemo = useMemo(() => {
    const basicInfoList: any[] = [
      {
        label: '询价截止日期',
        value: formatTime(detailInfo?.expireDate || '', 'YYYY-MM-DD'),
      },
      {
        label: '采购员',
        value: detailInfo?.purchaserName,
      },
      {
        label: '附件',
        value: <AttachmentPreview attachment={detailInfo?.inquiryAttachment} />,
      },
      {
        label: '备注',
        value: detailInfo?.remark,
      },
    ]

    return { basicInfoList }
  }, [detailInfo])
  const statusMatcher = supplierInquiryStatusEnum
    .getAttrMatcher('value')
    .value(detailInfo?.inquiryStatus as any)
  const columns: XhTableColumnTypeV5<QuotationItemDTO> = [
    {
      title: '序号',
      key: 'sortOrder',
      dataIndex: 'sortOrder',
    },
    {
      title: '状态',
      dataIndex: 'itemStatus',
      key: 'itemStatus',
      render: (val: string | undefined) => (
        <span
          className={supplierInquiryItemStatusEnum.getAttrByValue(
            val as any,
            'className',
          )}
        >
          {supplierInquiryItemStatusEnum.getLabelByValue(val as any)}
        </span>
      ),
    },
    {
      title: '来源唯一标识码',
      dataIndex: 'inquiryTaskNo',
      key: 'inquiryTaskNo',
    },
    {
      title: '客方物资名称',
      dataIndex: 'clientMaterialName',
      key: 'clientMaterialName',
    },
    {
      title: '品牌',
      dataIndex: 'clientMaterialBrand',
      key: 'clientMaterialBrand',
    },
    {
      title: '规格/型号',
      dataIndex: 'clientMaterialSpec',
      key: 'clientMaterialSpec',
    },
    {
      title: '单位',
      dataIndex: 'clientMaterialUnit',
      key: 'clientMaterialUnit',
    },
    {
      title: '数量',
      dataIndex: 'clientMaterialQty',
      key: 'clientMaterialQty',
    },
    {
      title: '物资描述',
      dataIndex: 'clientMaterialDesc',
      key: 'clientMaterialDesc',
    },
    {
      title: '技术规范编码',
      dataIndex: 'techSpecCode',
      key: 'techSpecCode',
    },
    {
      title: '产品限价（单价）',
      dataIndex: 'priceLimit',
      key: 'priceLimit',
    },
    {
      title: '客方备注',
      dataIndex: 'clientRemark',
      key: 'clientRemark',
    },
    {
      title: '交货地点',
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
    },
    {
      title: '报价要求',
      dataIndex: 'quotationRequirement',
      key: 'quotationRequirement',
    },
    {
      title: '操作',
      dataIndex: 'techSpecCode',
      key: 'techSpecCode',
      width: 160,
      render: (text, record) => {
        if (isItemTerminal(record)) return null
        return (
          <Space>
            {statusMatcher.labelIsIn(['待报价', '待重新报价']) && (
              <Button type="link" onClick={() => handleGiveUpQuotation(record)}>
                放弃
              </Button>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <>
                {isQuotationInfoEmpty(record) && (
                  <Button
                    type="link"
                    onClick={() => openEditModalForRecord(record)}
                  >
                    去报价
                  </Button>
                )}
                {!isQuotationInfoEmpty(record) && (
                  <Button
                    type="link"
                    onClick={() => openEditModalForRecord(record)}
                  >
                    修改报价
                  </Button>
                )}
              </>
            )}
          </Space>
        )
      },
    },
  ]
  const columnsExpand: XhTableColumnTypeV5<QuotationItemDTO> = [
    { title: '单价', dataIndex: 'unitPrice', key: 'unitPrice' },
    { title: '产品市场价', dataIndex: 'marketPrice', key: 'marketPrice' },
    {
      title: '物料编码',
      dataIndex: 'quoteProductCode',
      key: 'quoteProductCode',
    },
    { title: '名称', dataIndex: 'quoteProductName', key: 'quoteProductName' },
    { title: '品牌', dataIndex: 'quoteProductBrand', key: 'quoteProductBrand' },
    { title: '规格', dataIndex: 'quoteProductSpec', key: 'quoteProductSpec' },
    { title: '单位', dataIndex: 'quoteUnit', key: 'quoteUnit' },
    { title: '货期', dataIndex: 'deliveryPeriod', key: 'deliveryPeriod' },
    {
      title: '是否含运费',
      dataIndex: 'includeFreight',
      key: 'includeFreight',
      render: (val: number | undefined) =>
        val === 1 ? '是' : val === 0 ? '否' : '-',
    },
    { title: '配置明细', dataIndex: 'configDetail', key: 'configDetail' },
    {
      title: '参数差异点',
      dataIndex: 'paramDifference',
      key: 'paramDifference',
    },
    { title: '备注', dataIndex: 'remark', key: 'remark' },
    {
      title: '产品明细附件',
      dataIndex: 'attachment',
      key: 'attachment',
      render: (_: any, record: QuotationItemDTO) => (
        <AttachmentPreview attachment={record.attachment} />
      ),
    },
  ]

  return (
    <div
      className={cn(
        'py-[10px] px-[20px] pb-[100px] break-all',
        'outer-contaier',
      )}
    >
      <Row justify={'space-between'}>
        <Space>
          <span className="text-[18px] font-bold">询价单号：</span>
          <Skeleton loading={isLoading}>
            <span className="text-[18px] font-bold">
              {detailInfo?.inquiryNo}
            </span>
            {detailInfo?.inquiryTags?.includes('急单') && <UrgentOrder />}
            <span>
              {detailInfo?.inquiryTags?.includes('即将到期') && (
                <OutdateOrder />
              )}
              {detailInfo?.inquiryTags?.includes('已到期') && (
                <OutdateOrder title={'已到期'} />
              )}
            </span>
          </Skeleton>
        </Space>
        <div className="flex">
          <span>状态：</span>
          <InquiryStatusAdminTag status={detailInfo?.inquiryStatus} />
        </div>
      </Row>
      <CustomDivider />
      <Skeleton loading={isLoading}>
        <Row justify={'end'}>
          {detailInfo?.rejectReason && (
            <span className="text-[#CD3A15]">
              原因：{detailInfo?.rejectReason}
            </span>
          )}
        </Row>
        <Row>
          {detailMemo.basicInfoList.map((item) => {
            return (
              <Col
                span={6}
                key={item.label}
                className="flex py-[2px]"
                // {...item.colProps}
              >
                <div className="flex-shrink-0">{item.label}：</div>
                <div className="break-all">{item.value || '-'}</div>
              </Col>
            )
          })}
        </Row>
      </Skeleton>

      <BJDForm
        ref={bjdFormRef}
        isLoading={isLoading}
        form={form}
        item={detailInfo}
        groupCode={detailInfo?.groupCode}
      />
      <Skeleton loading={isLoading}>
        <div className="mb-[10px]">
          <RadioTabs
            radioItemDict={currentTableMemo.radioItemDict as any}
            defaultKey={currentTableMemo.defaultKey as any}
            onChange={(key) => setCurrentTabKey(key as any)}
          />
        </div>
        <XhTableV5
          className={styles.tableWithMinHeight}
          columns={columns}
          dataSource={currentTableMemo.dataSource}
          rowKey={getInquiryListRowKey}
          // pagination={true}
          scroll={{
            y: 'calc(100vh - 750px)',
          }}
          bordered={false}
          resizable
          pagination={{
            // current: state.quotationPageOption?.pageNo,
            pageSize: 20,
            // total: state.quotationPageOption?.totalCount,
            // onChange: (page, pageSize) => setQuotationPageOption(page, pageSize),
          }}
          expandable={{
            defaultExpandAllRows: true,
            expandedRowKeys: currentTableMemo.expandedRowKeys,
            expandIcon: () => null,
            columnWidth: 0,
            // columnTitle: '测试列表头',
            indentSize: 0,
            // expandIconColumnIndex: 0,
            expandedRowRender: (record) => (
              <div className="flex">
                <div className="w-[60px] font-bold flex items-center">
                  供方报价
                  <br />
                  信息
                </div>
                <div className="flex-1">
                  {!isQuotationInfoEmpty(record) && (
                    <XhTableV5
                      bordered={false}
                      resizable
                      columns={columnsExpand}
                      dataSource={[record]}
                      pagination={false}
                      size="small"
                      rowKey={(r) => r.inquiryItemId!}
                    />
                  )}
                  {isQuotationInfoEmpty(record) && (
                    <div className="flex justify-center items-center h-full">
                      未报价
                    </div>
                  )}
                </div>
              </div>
            ),
          }}
        />
      </Skeleton>
      <Modal
        open={state.editModalOpen}
        // okText="提交报价"
        // cancelText="取消"
        onCancel={closeEditModal}
        title={'提交报价'}
        width={1000}
        maskClosable={false}
        destroyOnClose={true}
        footer={
          <Row justify="end">
            <Space>
              {/* <Button onClick={closeEditModal}>取消</Button> */}
              <AsyncButton type="primary" onClick={submitDetailList}>
                提交
              </AsyncButton>
            </Space>
          </Row>
        }
      >
        <Form form={editForm} labelAlign="right">
          {state.editModalOpen && (
            <XJForm
              ref={xjFormRef}
              item={{
                items: currentTableMemo.editDataSource,
              }}
            />
          )}
        </Form>
      </Modal>
      <div className={styles['bottom-buttons-container']}>
        <Skeleton loading={isLoading}>
          <Space>
            {detailInfo?.lastTempSaveTime && (
              <div>
                <span>
                  上次暂存时间:
                  {formatTime(detailInfo?.lastTempSaveTime, 'YYYY-MM-DD HH:mm')}
                </span>
              </div>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <AsyncButton onClick={handleTempSave}>暂存</AsyncButton>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <ImportTemplateModal
                buttonText="导入"
                modalTitle="导入询价单"
                open={state.importModalOpen}
                onOpenChange={onImportOpenChange}
                confirmLoading={state.importConfirmLoading}
                onConfirm={onConfirmImport}
                downloadConfig={{ url: Template_url_inquiryImportSCP }}
                uploadProps={{
                  dataSource: state.importUploadList,
                  onChange: onImportFileChange,
                  getOriginFile: getImportOriginFile,
                  type: 'inquiryImportSCP',
                }}
              />
            )}
            <AsyncButton onClick={handleExport}>导出</AsyncButton>
            {statusMatcher.labelIsIn(['待接单']) && (
              <Tooltip title="先锁单，暂时不报价">
                <Button onClick={handleConfirmOrder}>确认接单</Button>
              </Tooltip>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <Button type="primary" onClick={handleSubmitQuotation}>
                提交报价
              </Button>
            )}
          </Space>
        </Skeleton>
      </div>
    </div>
  )
}
import {
  Button,
  Col,
  Row,
  Skeleton,
  Space,
  Table,
  Tooltip,
  Modal,
  Form,
  Spin,
} from 'antd'
import AsyncButton from '@/components/AsyncButton'
import UrgentOrder from '@/components/Icons/UrgentOrder'
import OutdateOrder from '@/components/Icons/OutdateOrder'
import { useMemo, useRef, useEffect } from 'react'
import styles from './styles.module.scss'
import CustomDivider from '@/components/CustomDivider'
import {
  supplierInquiryItemStatusEnum,
  supplierInquiryStatusEnum,
} from '@/global/enum'
import { useSetupHook } from './hooks'
import { formatTime } from '@/tools'
import InquiryStatusAdminTag from '@/components/Icons/tags/InquiryStatusAdminTag'
import { AttachmentPreview } from './components/AttachmentPreview'
import BJDForm from './components/BJDForm'
import XJForm, { XJFormRef } from './components/XJForm'
import RadioTabs from '@/components/RadioTabs'
import ImportTemplateModal from '@/components/ImportTemplateModal'
import { Template_url_inquiryImportSCP } from '@/api/template'
import { ColumnsType } from 'antd/lib/table'
import { QuotationItemDTO } from '@/api/inquiry'
import { cn } from '@xhgj/xh-jsutils'
import { XhTableColumnTypeV5, XhTableV5 } from '@xhgj/xh-components'
export function getInquiryListRowKey(record: QuotationItemDTO) {
  return record.inquiryItemId || ''
}
function isQuotationInfoEmpty(record: QuotationItemDTO) {
  // return !record.quoteUnitCode
  // itemStatus为空时当作待报价
  return (
    supplierInquiryItemStatusEnum.isValueInLabels(record.itemStatus, [
      '待报价',
    ]) || !record.itemStatus
  )
}
function isItemTerminal(record: QuotationItemDTO) {
  return supplierInquiryItemStatusEnum.isValueInLabels(record.itemStatus, [
    '已放弃',
    '无需报价',
  ])
}
export default function InquiryDetail() {
  const {
    state,
    toggleHideClientInfo,
    refreshPage,
    form,
    editForm,
    bjdFormRef,
    handleConfirmOrder,
    handleSubmitQuotation,
    handleTempSave,
    submitDetailList,
    handleExport,
    onImportOpenChange,
    onImportFileChange,
    getImportOriginFile,
    onConfirmImport,
    currentTableMemo,
    setCurrentTabKey,
    setQuotationPageOption,
    openEditModalForRecord,
    closeEditModal,
    handleGiveUpQuotation,
  } = useSetupHook()
  const { detailInfo, isLoading, hideClientInfo, quotationItemsPage } = state

  const xjFormRef = useRef<XJFormRef>(null)

  useEffect(() => {
    if (state.editModalOpen && state.editTabIndex !== undefined) {
      xjFormRef.current?.switchToTab(state.editTabIndex!)
    }
  }, [state.editModalOpen, state.editTabIndex])

  const detailMemo = useMemo(() => {
    const basicInfoList: any[] = [
      {
        label: '询价截止日期',
        value: formatTime(detailInfo?.expireDate || '', 'YYYY-MM-DD'),
      },
      {
        label: '采购员',
        value: detailInfo?.purchaserName,
      },
      {
        label: '附件',
        value: <AttachmentPreview attachment={detailInfo?.inquiryAttachment} />,
      },
      {
        label: '备注',
        value: detailInfo?.remark,
      },
    ]

    return { basicInfoList }
  }, [detailInfo])
  const statusMatcher = supplierInquiryStatusEnum
    .getAttrMatcher('value')
    .value(detailInfo?.inquiryStatus as any)
  const columns: XhTableColumnTypeV5<QuotationItemDTO> = [
    {
      title: '序号',
      key: 'sortOrder',
      dataIndex: 'sortOrder',
    },
    {
      title: '状态',
      dataIndex: 'itemStatus',
      key: 'itemStatus',
      render: (val: string | undefined) => (
        <span
          className={supplierInquiryItemStatusEnum.getAttrByValue(
            val as any,
            'className',
          )}
        >
          {supplierInquiryItemStatusEnum.getLabelByValue(val as any)}
        </span>
      ),
    },
    {
      title: '来源唯一标识码',
      dataIndex: 'inquiryTaskNo',
      key: 'inquiryTaskNo',
    },
    {
      title: '客方物资名称',
      dataIndex: 'clientMaterialName',
      key: 'clientMaterialName',
    },
    {
      title: '品牌',
      dataIndex: 'clientMaterialBrand',
      key: 'clientMaterialBrand',
    },
    {
      title: '规格/型号',
      dataIndex: 'clientMaterialSpec',
      key: 'clientMaterialSpec',
    },
    {
      title: '单位',
      dataIndex: 'clientMaterialUnit',
      key: 'clientMaterialUnit',
    },
    {
      title: '数量',
      dataIndex: 'clientMaterialQty',
      key: 'clientMaterialQty',
    },
    {
      title: '物资描述',
      dataIndex: 'clientMaterialDesc',
      key: 'clientMaterialDesc',
    },
    {
      title: '技术规范编码',
      dataIndex: 'techSpecCode',
      key: 'techSpecCode',
    },
    {
      title: '产品限价（单价）',
      dataIndex: 'priceLimit',
      key: 'priceLimit',
    },
    {
      title: '客方备注',
      dataIndex: 'clientRemark',
      key: 'clientRemark',
    },
    {
      title: '交货地点',
      dataIndex: 'deliveryAddress',
      key: 'deliveryAddress',
    },
    {
      title: '报价要求',
      dataIndex: 'quotationRequirement',
      key: 'quotationRequirement',
    },
    {
      title: '操作',
      dataIndex: 'techSpecCode',
      key: 'techSpecCode',
      width: 160,
      render: (text, record) => {
        if (isItemTerminal(record)) return null
        return (
          <Space>
            {statusMatcher.labelIsIn(['待报价', '待重新报价']) && (
              <Button type="link" onClick={() => handleGiveUpQuotation(record)}>
                放弃
              </Button>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <>
                {isQuotationInfoEmpty(record) && (
                  <Button
                    type="link"
                    onClick={() => openEditModalForRecord(record)}
                  >
                    去报价
                  </Button>
                )}
                {!isQuotationInfoEmpty(record) && (
                  <Button
                    type="link"
                    onClick={() => openEditModalForRecord(record)}
                  >
                    修改报价
                  </Button>
                )}
              </>
            )}
          </Space>
        )
      },
    },
  ]
  const columnsExpand: XhTableColumnTypeV5<QuotationItemDTO> = [
    { title: '单价', dataIndex: 'unitPrice', key: 'unitPrice' },
    { title: '产品市场价', dataIndex: 'marketPrice', key: 'marketPrice' },
    {
      title: '物料编码',
      dataIndex: 'quoteProductCode',
      key: 'quoteProductCode',
    },
    { title: '名称', dataIndex: 'quoteProductName', key: 'quoteProductName' },
    { title: '品牌', dataIndex: 'quoteProductBrand', key: 'quoteProductBrand' },
    { title: '规格', dataIndex: 'quoteProductSpec', key: 'quoteProductSpec' },
    { title: '单位', dataIndex: 'quoteUnit', key: 'quoteUnit' },
    { title: '货期', dataIndex: 'deliveryPeriod', key: 'deliveryPeriod' },
    {
      title: '是否含运费',
      dataIndex: 'includeFreight',
      key: 'includeFreight',
      render: (val: number | undefined) =>
        val === 1 ? '是' : val === 0 ? '否' : '-',
    },
    { title: '配置明细', dataIndex: 'configDetail', key: 'configDetail' },
    {
      title: '参数差异点',
      dataIndex: 'paramDifference',
      key: 'paramDifference',
    },
    { title: '备注', dataIndex: 'remark', key: 'remark' },
    {
      title: '产品明细附件',
      dataIndex: 'attachment',
      key: 'attachment',
      render: (_: any, record: QuotationItemDTO) => (
        <AttachmentPreview attachment={record.attachment} />
      ),
    },
  ]

  return (
    <div
      className={cn(
        'py-[10px] px-[20px] pb-[100px] break-all',
        'outer-contaier',
      )}
    >
      <Row justify={'space-between'}>
        <Space>
          <span className="text-[18px] font-bold">询价单号：</span>
          <Skeleton loading={isLoading}>
            <span className="text-[18px] font-bold">
              {detailInfo?.inquiryNo}
            </span>
            {detailInfo?.inquiryTags?.includes('急单') && <UrgentOrder />}
            <span>
              {detailInfo?.inquiryTags?.includes('即将到期') && (
                <OutdateOrder />
              )}
              {detailInfo?.inquiryTags?.includes('已到期') && (
                <OutdateOrder title={'已到期'} />
              )}
            </span>
          </Skeleton>
        </Space>
        <div className="flex">
          <span>状态：</span>
          <InquiryStatusAdminTag status={detailInfo?.inquiryStatus} />
        </div>
      </Row>
      <CustomDivider />
      <Skeleton loading={isLoading}>
        <Row justify={'end'}>
          {detailInfo?.rejectReason && (
            <span className="text-[#CD3A15]">
              原因：{detailInfo?.rejectReason}
            </span>
          )}
        </Row>
        <Row>
          {detailMemo.basicInfoList.map((item) => {
            return (
              <Col
                span={6}
                key={item.label}
                className="flex py-[2px]"
                // {...item.colProps}
              >
                <div className="flex-shrink-0">{item.label}：</div>
                <div className="break-all">{item.value || '-'}</div>
              </Col>
            )
          })}
        </Row>
      </Skeleton>

      <BJDForm
        ref={bjdFormRef}
        isLoading={isLoading}
        form={form}
        item={detailInfo}
        groupCode={detailInfo?.groupCode}
      />
      <Skeleton loading={isLoading}>
        <div className="mb-[10px]">
          <RadioTabs
            radioItemDict={currentTableMemo.radioItemDict as any}
            defaultKey={currentTableMemo.defaultKey as any}
            onChange={(key) => setCurrentTabKey(key as any)}
          />
        </div>
        <XhTableV5
          className={styles.tableWithMinHeight}
          columns={columns}
          dataSource={currentTableMemo.dataSource}
          rowKey={getInquiryListRowKey}
          // pagination={true}
          scroll={{
            y: 'calc(100vh - 750px)',
          }}
          bordered={false}
          resizable
          pagination={{
            // current: state.quotationPageOption?.pageNo,
            pageSize: 20,
            // total: state.quotationPageOption?.totalCount,
            // onChange: (page, pageSize) => setQuotationPageOption(page, pageSize),
          }}
          expandable={{
            defaultExpandAllRows: true,
            expandedRowKeys: currentTableMemo.expandedRowKeys,
            expandIcon: () => null,
            columnWidth: 0,
            // columnTitle: '测试列表头',
            indentSize: 0,
            // expandIconColumnIndex: 0,
            expandedRowRender: (record) => (
              <div className="flex">
                <div className="w-[60px] font-bold flex items-center">
                  供方报价
                  <br />
                  信息
                </div>
                <div className="flex-1">
                  {!isQuotationInfoEmpty(record) && (
                    <XhTableV5
                      bordered={false}
                      resizable
                      columns={columnsExpand}
                      dataSource={[record]}
                      pagination={false}
                      size="small"
                      rowKey={(r) => r.inquiryItemId!}
                    />
                  )}
                  {isQuotationInfoEmpty(record) && (
                    <div className="flex justify-center items-center h-full">
                      未报价
                    </div>
                  )}
                </div>
              </div>
            ),
          }}
        />
      </Skeleton>
      <Modal
        open={state.editModalOpen}
        // okText="提交报价"
        // cancelText="取消"
        onCancel={closeEditModal}
        title={'提交报价'}
        width={1000}
        maskClosable={false}
        destroyOnClose={true}
        footer={
          <Row justify="end">
            <Space>
              {/* <Button onClick={closeEditModal}>取消</Button> */}
              <AsyncButton type="primary" onClick={submitDetailList}>
                提交
              </AsyncButton>
            </Space>
          </Row>
        }
      >
        <Form form={editForm} labelAlign="right">
          {state.editModalOpen && (
            <XJForm
              ref={xjFormRef}
              item={{
                items: currentTableMemo.editDataSource,
              }}
            />
          )}
        </Form>
      </Modal>
      <div className={styles['bottom-buttons-container']}>
        <Skeleton loading={isLoading}>
          <Space>
            {detailInfo?.lastTempSaveTime && (
              <div>
                <span>
                  上次暂存时间:
                  {formatTime(detailInfo?.lastTempSaveTime, 'YYYY-MM-DD HH:mm')}
                </span>
              </div>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <AsyncButton onClick={handleTempSave}>暂存</AsyncButton>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <ImportTemplateModal
                buttonText="导入"
                modalTitle="导入询价单"
                open={state.importModalOpen}
                onOpenChange={onImportOpenChange}
                confirmLoading={state.importConfirmLoading}
                onConfirm={onConfirmImport}
                downloadConfig={{ url: Template_url_inquiryImportSCP }}
                uploadProps={{
                  dataSource: state.importUploadList,
                  onChange: onImportFileChange,
                  getOriginFile: getImportOriginFile,
                  type: 'inquiryImportSCP',
                }}
              />
            )}
            <AsyncButton onClick={handleExport}>导出</AsyncButton>
            {statusMatcher.labelIsIn(['待接单']) && (
              <Tooltip title="先锁单，暂时不报价">
                <Button onClick={handleConfirmOrder}>确认接单</Button>
              </Tooltip>
            )}
            {statusMatcher.labelIsIn(['待接单', '待报价', '待重新报价']) && (
              <Button type="primary" onClick={handleSubmitQuotation}>
                提交报价
              </Button>
            )}
          </Space>
        </Skeleton>
      </div>
    </div>
  )
}
